import { EntitySortUtil } from '@core/utils/entity-sort.util';
import { Contact } from '@shared/contact/contact';

export class ContactSort {
  static byFullName = (a: Contact, b: Contact): number => {
    const resultByName = ContactSort.byName(a, b);
    if (resultByName !== 0) {
      return resultByName;
    }

    return ContactSort.byFirstName(a, b);
  };

  static byName = (a: Contact, b: Contact): number => {
    return EntitySortUtil.byStringValue(a.name, b.name);
  };

  static byFirstName = (a: Contact, b: Contact): number => {
    return EntitySortUtil.byStringValue(a.firstName, b.firstName);
  };

  static byEmailAddress = (a: Contact, b: Contact): number => {
    return EntitySortUtil.byStringValue(a.emailAddress, b.emailAddress);
  };
}
